import axios from "axios";
import qs from "qs";
const api = "/creditapi";

/**
 * 获取查询日志
 * @param pageNum
 * @param pageSize
 * @returns {AxiosPromise<any>}
 */
export function getXzcfList({   ztmc,
                                type,
                                cfjg,
                                startTime,
                                endTime,
                                pageNum}) {
    return axios.get(api + "/punishment/getErrPageList", {
        params: {
            ztmc,
            type,
            cfjg,
            startTime,
            endTime,
            pageNum
        }
    });
}

export function findONE( id ) {
    return axios.get(api + "/punishment/findErrOne", {
        params: { id }
    });
}




/**
 * 修改行政处罚
 * @returns {AxiosPromise<any>}
 */
export function updateXzcf({ CFJG, CF_USCC, LYDW, LY_USCC,
                               USCC, bz, cfje, cfjzq, cflb,
                               cfnr, cfyj, cfyxq, fddbr, fddbrlx,
                               fddbrzjh, jdrq, msje, otherDesc,
                               sfxf, wflx, wfss, wsh, xzxdrlb,
                               xzxdrmc, zjhm, zjlx, zkbh, id, status, stype,
                               zjlxOther,fddbrLxOther,xzcfGsdj,unId,cfjdwsmc }) {
    return axios.post(
        api + "/punishment/edit",
        qs.stringify({
            CFJG, CF_USCC, LYDW, LY_USCC,
            USCC, bz, cfje, cfjzq, cflb,
            cfnr, cfyj, cfyxq, fddbr, fddbrlx,
            fddbrzjh, jdrq, msje, otherDesc,
            sfxf, wflx, wfss, wsh, xzxdrlb,
            xzxdrmc, zjhm, zjlx, zkbh, id, status, stype,
            zjlxOther,fddbrLxOther,xzcfGsdj,unId,cfjdwsmc
        })
    );
}


/**
 * 处罚异常数据（交换）导入
 * @param formData
 * @returns {AxiosPromise}
 */
export function importData(formData) {
    return axios({
        url: api + "/punishment/importData",
        method: "post",
        data: formData,
        headers: {"Content-Type": "application/x-www-form-urlencoded"}
    });
}

/**
 * 获取错误详情
 * @param pageNum
 * @param pageSize
 * @returns {AxiosPromise<any>}
 */
export function getErrorList({   id,uscc,wsh,
                                 current}) {
    return axios.get(api + "/punishment/getErrPage", {
        params: {
            id,
            uscc,
            wsh,
            current
        }
    });
}
